import { NotificationLocation } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNotificationLocations: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<NotificationLocation[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/notifications/locations`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NotificationLocation[]>(fetchContext.errorStore, response, 'get notification locations'));
